<script setup lang="ts">
import {
    ActionButton,
    BaseDialog,
    FullScreenLoader,
    OrganizationSelector,
    StackLayout
} from '@rfc/rfc-components-library'
import { organizationService } from '@rfc/rfc-components-library/services'
import type { DeviceModel } from '@rfc/rfc-components-library/types'
import { ref } from 'vue'

type Props = {
    data?: Partial<DeviceModel>
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const open = ref(false)
const loading = ref(false)

const selectedOrganizationId = ref<number>()

const confirmOrganizationAttach = () => {
    if ((!props.data?.device_id && !props.data?.id) || !selectedOrganizationId.value) return
    loading.value = true
    organizationService
        .attachDeviceToOrganization(
            selectedOrganizationId.value,
            props.data?.device_id ?? props.data.id!
        )
        .then(() => {
            setTimeout(() => {
                emit('refresh')
                open.value = false
            }, 1000)
        })
        .finally(() => (loading.value = false))
}
</script>

<template>
    <FullScreenLoader :loading="loading" />
    <ActionButton
        :label="$t('organization.buttons.associateDevice')"
        @click="open = true"
        v-bind="$attrs" />
    <BaseDialog
        :title="$t('organization.buttons.associateDevice')"
        :open="open"
        @close="open = false"
        @confirm="confirmOrganizationAttach"
        :disabled="!selectedOrganizationId"
        class="dialog-with-dropdown">
        <template #content>
            <StackLayout class="w-full">
                <OrganizationSelector
                    :label="$t('organization.model.organizationName')"
                    :organizationId="selectedOrganizationId"
                    @select="selectedOrganizationId = $event?.id"
                    class="fixed-dialog-dropdown modal-selector-w-full" />
            </StackLayout>
        </template>
    </BaseDialog>
</template>
